<div class="container-fluid cc-bg-grey c-border-top">
    <div class="row">
        <div class="col pt-3 pb-3">

            <small class="ml-5 cc-text-white">Copyright © {{trademark | date:'yyyy'}} Co-Operative Computing. All rights reserved.</small>

        </div>
    </div>
</div>